import { render, staticRenderFns } from "./CompanyManagementMemberTier.vue?vue&type=template&id=a3734428&scoped=true"
import script from "./CompanyManagementMemberTier.vue?vue&type=script&lang=js"
export * from "./CompanyManagementMemberTier.vue?vue&type=script&lang=js"
import style0 from "./CompanyManagementMemberTier.vue?vue&type=style&index=0&id=a3734428&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3734428",
  null
  
)

export default component.exports